const numeral = require('numeral')

numeral.locale('en', {
  delimiters: {
    thousands: ',',
    decimal: '.'
  }
})

numeral.localeData().delimiters.thousands = ',';

export default numeral
